<script>
import SectionNavItem from './SectionNavItem'

export default {
  name: 'SectionNav',
  components: {
    SectionNavItem
  },
  
  // should reflect sidenav breakpoint values set in css/global/variables.less
  mq: {
    sm: '(max-width: 46.99em)',
    lg: '(min-width: 47em)'
  },
  
  data() {
    return {
      navListOpen: false
    }
  },
  
  computed: {
    mqSm() {
      return this.$mq.sm
    }
  },
  
  methods: {
    handleCollapse(el, btn, condition) {
      // wrangle all the styling and DOM-related toggling for list collapse/expansion
      el.style.maxHeight = condition ? `${el.scrollHeight}px` : null
      condition
        ? el.classList.add('is-visible')
        // delay hiding long enough to first allow the CSS transition to do its thing
        : setTimeout(() => { el.classList.remove('is-visible') }, 200)
      el.setAttribute('aria-hidden', !condition)
      btn.setAttribute('aria-expanded', condition)
    },
    
    navListToggle(e) {
      e.preventDefault()
      this.navListOpen = !this.navListOpen
      this.handleCollapse(this.$refs.navList, e.target, this.navListOpen)
    },
    
    navSublistToggle(list) {
      // make the main navList's maxHeight respond to changes:
      this.$refs.navList.style.maxHeight = (this.$refs.navList.scrollHeight + list.listEl.scrollHeight) + 'px'
      this.handleCollapse(list.listEl, list.btnEl, list.isOpen)
    }
  },

  watch: {
    mqSm(isSm) {
      this.navListOpen = false

      if ( !isSm ) {
        this.$refs.navList.style.maxHeight = null
        this.$refs.navList.removeAttribute('aria-hidden')
      } else {
        this.$refs.navList.setAttribute('aria-hidden', !this.navListOpen)
        this.$refs.navList.style.maxHeight = '0'
      }
    }
  },
  
  mounted() {
    // initialize WAI-ARIA attributes and visibility
    if (this.$mq.sm) {
      this.$refs.navList.setAttribute('aria-hidden', !this.navListOpen)
      this.$refs.navListBtn.setAttribute('aria-expanded', this.navListOpen)
    }
  }
  
  
}
</script>



// WEBPACK FOOTER //
// js/SectionNav.vue